import { render, staticRenderFns } from "./ApprenticeCard.vue?vue&type=template&id=ffadcaf0&scoped=true&"
import script from "./ApprenticeCard.ts?vue&type=script&lang=js&"
export * from "./ApprenticeCard.ts?vue&type=script&lang=js&"
import style0 from "./ApprenticeCard.css?vue&type=style&index=0&id=ffadcaf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffadcaf0",
  null
  
)

export default component.exports